import { render, staticRenderFns } from "./FeaturedCategories.vue?vue&type=template&id=782630a2"
import script from "./FeaturedCategories.vue?vue&type=script&lang=js"
export * from "./FeaturedCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports